module.exports = __webpack_public_path__ + "static/media/bread-bg.619e60ce.jpg";